/**
 * useTaskWorkReports — the task binding of ``useEntityWorkReports`` (D1).
 *
 * D2a generalised the hook so the tenant tab could reuse it verbatim.
 * This wrapper keeps the D1 call site (`useTaskWorkReports(taskId)`)
 * exactly as it was, which is also the cheapest proof that the
 * extraction changed no behaviour on the task page.
 */
import { useEntityWorkReports } from "./entityWorkReports/useEntityWorkReports";

export { WORK_REPORTS_PAGE_SIZE as TASK_REPORTS_PAGE_SIZE } from "./entityWorkReports/useEntityWorkReports";

export function useTaskWorkReports(taskId) {
  return useEntityWorkReports({ scope: "task", entityId: taskId });
}

export default useTaskWorkReports;
